<template>
  <base-page
    :title="title"
  >
    <template #main>
      <project-create-update-form />
    </template>
  </base-page>
</template>
<script>
import ProjectCreateUpdateForm from '@/components/Project/ProjectCreateUpdateForm'
import BasePage from "@/views/BasePage"

export default {
  components: {
    BasePage,
    ProjectCreateUpdateForm
  },
  data() {
    return {
      project: { }
    }
  },
  computed: {
    title() {
      return this.project == null ? this.$t('project.page.create') : this.$t('project.page.update')
    }
  },
}
</script>
